<template>
    <div id="ticket-component">
        <form id="formTicketQuoter" class="animated fadeIn formTicketQuoter">
            <div class="row">
                <input type="hidden" name="quoter_id" :value="quoter_id">
                <div class="col-12 col-sm-6">
                    <input type="text" name="price" class="al-inputs required scr-input" placeholder="Costo" id="price">
                </div>
                <div class="col-12 col-sm-6">
                    <date-picker inputName="payment_date" input-class="mx-input scr-input" v-model="payment_date" format="YYYY-MM-dd" placeholder="Fecha de Pago" lang="es"></date-picker>
                </div>
                <div class="col-12 col-sm-12">
                    <div class="fotoUploader">
                        <span class="btn btn-file">
                            Documento <br> <i class="fas fa-upload"></i>
                            <input type="file" class="required" accept="image/*,.pdf" data-label="avatar"
                                   name="ticket_file" v-on:change="getLogo" placeholder="Documento">
                        </span>
                        <span class="label-file-papeleria alert alert-info logo"></span>
                    </div>
                </div>
                <div class="col-12 col-sm-12">
                    <p class="fotoUploader">
                        <strong>Formatos permitidos: .jpeg, .png, .jpg, .gif, .pdf, con un peso máximo de 500kb</strong>
                    </p>
                </div>
                <div class="col-12 col-sm-12">
                    <button id="dyn-button" type="button" class="btn btn-primary addNote" v-on:click="guardar()">
                        {{ tituloBtn }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import {myMixins} from "../mixins/myMixins";
import {getFormData} from "../../Utils/getDataForm";

import {ticketQuoterWorkerService} from "../../Services/TicketQuoterWorker.service";

export default {
    name: 'ticket',
    mixins: [myMixins],
    components: {
        DatePicker: () => import('vue2-datepicker'),
    },
    props: {
        quoter_id: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            isBusy: false,
            modificar: false,
            type_ticket: 0,
            payment_date: '',
            clients: [],
            tituloBtn: 'Agregar Documento',
            params: {
                limit: 10,
                page: 1,
                where: []
            }
        }
    },
    methods: {
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formTicketQuoter');
            if (respVal) {
                this.disableSubmitBtn(true);
                const formData = getFormData('formTicketQuoter');
                resp = await ticketQuoterWorkerService.saveOne(formData, {
                    isForm: true,
                    onUploadProgress: this.onUploadProgress
                });
                //this.ticket.archivo = '';
                this.getAlert(resp.process, true);
                this.disableSubmitBtn(false);
                await this.index();
                this.$emit('close-modal');
            }
            this.modificar = false;
        },
        getLogo(event) {
            this.getNameFile(event, 'logo');
        },
    },
    mounted() {

    }
}
</script>
